import { STATUS_META, STATUS_PALETTE } from "@/lib/constants";

export function StatusBadge({ status, id }) {
  const m = STATUS_META[status] || STATUS_PALETTE.slate;
  return (
    <span
      data-testid={id ? `practice-status-badge-${id}` : undefined}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${m.bg} ${m.text} ${m.border}`}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: m.dot }} />
      {status}
    </span>
  );
}
